import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { toast, ToastContainer } from 'react-toastify';
import app from '../firebase/config';

export const PostsContext = createContext({});

function PostsProvider({ children }) {

    const [facebookPosts, setFacebookPosts] = useState()
    const [instagramPosts, setInstagramPosts] = useState()
    const [products, setProducts] = useState([])
    const [ids, setIds] = useState([]);
    const [btnDisable, setBtnDisable] = useState(false)
    const [previewNameFacebook, setPreviewNameFacebook] = useState([])
    const [previewNameFacebookFormatted, setPreviewNameFacebookFormatted] = useState()
    const [imagePreview, setImagePreview] = useState()
    const [file, setFile] = useState()
    const [namePost, setNamePost] = useState()
    const [descriptionPost, setDescriptionPost] = useState()
    const [googlePosts,setGooglePosts] = useState([])

    
    const storageFacebook = async () => {

        if (ids.length == 0) {
            return toast.error("Informe um produto", {
                autoClose: 1500
            })
        }

        setBtnDisable(true)
        const loadingToastId = toast.loading("Enviando para o facebook...");

        const response = await api.post("posts/storage/facebook", {
            ids: ids
        })
        getFacebookPosts()
        setIds([])
        setFile()
        setNamePost()
        setImagePreview()


        if (response.status == 200) {
            setBtnDisable(false)
            return toast.update(loadingToastId, {
                render: "Posts enviados com sucesso!",
                type: "sucess",
                isLoading: false,
                autoClose: 1000
            });
        }

    }
    const storageGoogle = async () => {

        
        if (ids.length == 0) {
            return toast.error("Informe um produto", {
                autoClose: 1500
            })
        }

        setBtnDisable(true)

        const loadingToastId = toast.loading("Enviando para o google...");

        const response = await api.post("google/storage",{
            ids:ids
        })

        if(response.status == 200){
            setBtnDisable(false)
            getGooglePosts()
            return toast.update(loadingToastId, {
                render: "Produtos em análise, confira no seu google merchant center",
                type: "sucess",
                isLoading: false,
                autoClose: 6900
            });
        }

    }
    const storageInstagramAll = async () => {
        
        if (ids.length == 0) {
            return toast.error("Informe um produto", {
                autoClose: 1500
            })
        }

        setBtnDisable(true)
        const loadingToastId = toast.loading("Enviando para o instagram...");

        const response = await api.post("posts/storage/instagaram", {
            ids: ids
        })
        getInstagramPosts()
        setIds([])
        setFile()
        setNamePost()
        setImagePreview()


        if (response.status == 200) {
            setBtnDisable(false)
            return toast.update(loadingToastId, {
                render: "Posts enviados com sucesso!",
                type: "sucess",
                isLoading: false,
                autoClose: 1000
            });
        }

    }
    const storageInstagram = async () => {
        setBtnDisable(true)
        const loadingToastId = toast.loading("Enviando para o instagram...");

        await storageImageInstagram()
        toast.update(loadingToastId, {
            render: "Post enviado com sucesso!",
            isLoading: false,
            autoClose: 1000
        });
        setBtnDisable(false)
        getInstagramPosts()
    }
    const getFacebookPosts = async () => {
        const response = await api.get("posts/get/facebook")
        if (response.status == 200) {
            setFacebookPosts(response.data)
        }
    }
    const getInstagramPosts = async () => {
        const response = await api.get("posts/get/instagram")
        if (response.status == 200) {
            setInstagramPosts(response.data)
        }
    }
    const getGooglePosts = async () => {

        const response = await api.get("google/get")
        if(response.status == 200){
            setGooglePosts(response.data)
        }

    }
    const deleteFacebookPost = async (id) => {
        const loadingToastId = toast.loading("Processando o pedido...");
        const response = await api.delete(`posts/facebook/post/${id}`)

        if (response.status == 200) {
            setFacebookPosts([])
            getFacebookPosts()
            return toast.update(loadingToastId, {
                render: "Post deletado com sucesso!",
                type: "sucess",
                isLoading: false,
                autoClose: 1000
            });
        }

    }
    const deleteInstagram = async (id) => {
        const response = await api.delete(`posts/delete/instagram/${id}`)
        if (response.status = 200) {
            setInstagramPosts([])
            toast.success("Post deletado com sucesso", { autoClose: 1500 })
            getInstagramPosts()
        }

    }
    const getProducts = async (e) => {
        const response = await api.get(`panel/product/by/name/${e}`)
        if (response.status == 200) {
            setProducts(response.data)
            return
        }

    }
    const getByName = async (e) => {
        if (e == "") {
            getFacebookPosts()
            return
        }
        const response = await api.get(`posts/get/facebook/by/name/${e}`)

        if (response.status == 200) {
            setFacebookPosts(response.data)
            return
        }

    }
    const handeImage = async (file) => {

        const { type } = file

        const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
        const verifySupportedType = supportedTypes.includes(type)


        if (!verifySupportedType) {
            return toast.error("Formato de imagem não suportado!")
        }


        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = async () => {
            setImagePreview(reader.result)
            setFile(file)
        }

    }
    const storagePersonalizateFacebook = async () => {

        if (!namePost) {
            return toast.error("Informe um nome do post", {
                autoClose: 1500
            })
        }
        if (!file) {
            return toast.error("Informe uma imagem", {
                autoClose: 1500
            })
        }
        if (!descriptionPost) {
            return toast.error("Informe uma descrição", {
                autoClose: 1500
            })
        }
        setBtnDisable(true)
        await storageImage()
        setBtnDisable(false)
        setFile()
        setNamePost()
        setImagePreview()
        getFacebookPosts()
    }
    const storageImage = async () => {


        const loadingToastId = toast.loading("Enviando para o facebook...");

        return app.storage().ref(`/pages/images/${file.name}`).put(file)
            .then(() => {
                return app.storage().ref(`/pages/images/${file.name}`).getDownloadURL();
            })
            .then(image => {
                toast.update(loadingToastId, {
                    render: "Post enviado com sucesso!",
                    isLoading: false,
                    autoClose: 1000
                });

                return api.post("posts/storage/facebook/personalizate", {
                    namePost: namePost,
                    image: image,
                    descriptionText: previewNameFacebook
                })

            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${file.name}:`, error);
            });


    }
    const storageImageInstagram = async () => {

        return app.storage().ref(`/pages/images/${file.name}`).put(file)
            .then(() => {
                return app.storage().ref(`/pages/images/${file.name}`).getDownloadURL();
            })
            .then(image => {

                return api.post("posts/storage/instagram/personalizate", {
                    name_post: namePost,
                    image_url: image,
                    description: previewNameFacebook,
                })

            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${file.name}:`, error);
            });


    }

    return (
        <PostsContext.Provider value={{
            storageFacebook,
            getFacebookPosts,
            facebookPosts,
            getProducts,
            products,
            setIds,
            ids,
            deleteFacebookPost,
            btnDisable,
            setPreviewNameFacebook,
            previewNameFacebook,
            setPreviewNameFacebookFormatted,
            previewNameFacebookFormatted,
            imagePreview,
            handeImage,
            setDescriptionPost,
            storagePersonalizateFacebook,
            setNamePost,
            getByName,
            getInstagramPosts,
            instagramPosts,
            deleteInstagram,
            storageInstagram,
            storageInstagramAll,
            storageGoogle,
            getGooglePosts,
            googlePosts
        }}>
            {children}
        </PostsContext.Provider>
    );
}

export default PostsProvider;
